import { useMemo, useState } from "react";
import { useNavigate } from "react-router";

import { URLS } from "config/urls";
import { CheckCircleOutlineIcon } from "icons";
import theme from "theme";
import { colors } from "theme/palette";

import Button from "components/Button";
import Dialog, { DialogActions, DialogContent } from "components/Dialog";
import Text from "components/Text";

import { useSignedUser } from "entities/Auth/sdk";

export interface IDraftSavedSuccessfullyDialogButton {
  applicationName: string;
}

const DraftSavedSuccessfullyDialogButton = ({
  applicationName,
}: IDraftSavedSuccessfullyDialogButton) => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const { data: user } = useSignedUser();

  const buttonText = useMemo(() => {
    return user?.company_is_paying_customer ? "Intake dashboard" : "Dashboard";
  }, [user?.company_is_paying_customer]);

  return (
    <>
      <Button
        color="secondary"
        variant="outlined"
        onClick={() => setIsOpen(true)}
        sx={{ whiteSpace: "nowrap" }}
      >
        Save draft
      </Button>
      <Dialog open={isOpen} maxWidth="sm" onClose={() => setIsOpen(false)}>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: theme.spacing(4, 12),
          }}
        >
          <CheckCircleOutlineIcon color="primary" sx={{ fontSize: 68 }} />

          <Text variant="h1" marginTop={3} marginBottom={1}>
            Draft successfully saved!
          </Text>

          <Text variant="text1" color={colors.gray80}>
            Intake name: <b>{applicationName}</b>
          </Text>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center", marginBottom: 4 }}>
          <Button
            color="secondary"
            variant="outlined"
            onClick={() => navigate(URLS.LANDING_PAGE)}
          >
            {buttonText}
          </Button>
          <Button onClick={() => setIsOpen(false)}>Continue editing</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DraftSavedSuccessfullyDialogButton;
